module.exports = __webpack_public_path__ + "static/media/Simon_Lycett_getty_desktop.d6b3d617.jpg";